import useGetAggregat from "./useGetAggregat";
import useGetDetails from "./useGetDetails";
import useGetMarkers from "./useGetMarkers";
import useGetPlayList from "./useGetPlayList";
import useGetProfile from "./useGetProfile";
import useGetRecommendationList from "./useGetRecommendationList";
import useUserSettings from "./useUserSettings";
import useVideoSettings from "./useVideoSettings";
import useWebListConfig from "./useWebListConfig";

const useGetData = () => {
    useGetDetails(); 
    useGetProfile();
    useGetAggregat(); 
    useGetMarkers();
    useGetPlayList();  
    useGetRecommendationList(); 
    useUserSettings();
    useVideoSettings();
    useWebListConfig();
}

export default useGetData;